import { getFeedsReviewsType } from '@/pages/opinion/utils/text';
import {
  commentType,
  formatTime,
  monitorSourceName,
  tryTransNumber,
  transRegion,
  biggerOrTo,
  equalAndTo,
  sentimentNumber,
  hideSentimentFunc,
  renderHelperLiveBroadcastViews,
} from '../../render-helper';

export default function socialMediaColumns(params: any) {
  const { hideSentimentRating } = params;
  const list = [
    {
      header: `Parent_comment_id
  (Only replies have Parent_comment_id, which indicates the id of the post.
  Use the reply's Parent_comment_id to find all the replies of the post.
  Or use the comment_id of the post to find all the replies for that post.)`,
      render: 'comment_parent_id',
      renderHelper: [tryTransNumber, equalAndTo('-1', '')],
      width: 44,
    },
    {
      header: `Parent Comment Url`,
      render: 'parent_comment_url',
      width: 44,
    },
    {
      header: `Comment_id
  (Only posts have Comment_id)`,
      render: 'comment_id',
      renderHelper: [tryTransNumber, equalAndTo('-1', '')],
      width: 44,
    },
    {
      header: 'Comment_type',
      children: [],
      renderHelper: [commentType],
    },
    { header: 'comment_uin', render: 'comment_uin' },
    { header: 'channel', render: 'channel_name' },
    {
      header: 'Monitor Source',
      renderHelper: [monitorSourceName],
    },
    {
      header: 'Review Type',
      renderHelper: [getFeedsReviewsType],
    },
    {
      header: 'Sentiment',
      render: 'sentiment_rating',
      renderHelper: [hideSentimentRating ? hideSentimentFunc : sentimentNumber],
      width: 20,
      numFmt: ['0.00'],
    },
    { header: 'Reviewer', render: 'reviewer' },
    {
      header: 'Content_Original',
      render: 'content',
    },
    {
      header: 'Content_Chinese',
      render: 'content_to_zh',
    },
    {
      header: 'Content_English',
      render: 'content_to_en',
    },
    { header: 'URL', render: 'content_url' },
    {
      header: 'Date',
      render: 'comment_time',
      renderHelper: [formatTime('YYYY-MM-DD')],
    },
    {
      header: 'Time(UTC+8:00)',
      render: 'comment_time',
      renderHelper: [formatTime('YYYY-MM-DD HH:mm:ss')],
    },
    {
      header: 'Language',
      render: 'language',
      renderHelper: [transRegion(3)],
    },
    { header: 'Topic', render: 'topic' },
    {
      header: 'Engagement',
      render: 'engagement',
      numFmt: '#,##',
      renderHelper: [biggerOrTo(0, '')],
    },
    {
      header: 'Like',
      render: 'tweets_like',
      numFmt: '#,##',
      renderHelper: [biggerOrTo(0, '')],
    },
    {
      header: 'Dislike',
      render: 'tweets_unlike',
      numFmt: '#,##',
      renderHelper: [biggerOrTo(0, '')],
    },
    {
      header: 'Share',
      render: 'tweets_retweet',
      numFmt: '#,##',
      renderHelper: [biggerOrTo(0, '')],
    },
    {
      header: 'Comment',
      render: 'tweets_reply',
      numFmt: '#,##',
      renderHelper: [biggerOrTo(0, '')],
    },
    {
      header: 'View',
      render: 'view',
      numFmt: '#,##',
      renderHelper: [biggerOrTo(0, '')],
    },
    {
      header: 'Subscribe',
      render: 'subscribe',
      numFmt: '#,##',
      renderHelper: [biggerOrTo(0, '')],
    },
    {
      header: 'Live Broadcast Views',
      render: 'live_count',
      numFmt: '#,##',
      renderHelper: [renderHelperLiveBroadcastViews],
      width: 30,
    },
    {
      header: 'Description',
      render: 'description',
    },
    { header: 'CTGR1', render: 'ctgr_1' },
    { header: 'CTGR2', render: 'ctgr_2' },
    { header: 'CTGR3', render: 'ctgr_3' },
  ];

  return list;
}
